/* tslint:disable:no-shadowed-variable */
import * as R from 'ramda'
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { LatestVisitActionNames, LatestVisitMutationNames } from './keys'
import { getters } from './getters'

import { PatientWithLatestVisitState } from '@/store/modules/patient-with-latest-visit/types'
import { GetPatientWithLatestVisitByIdDto, getPatientWithLatestVisitByIdQuery } from '@/jsonapi/PatientWithLatestVisit'
import { addOrUpdateSameKeyObjectInArray } from '@/store/utils/api'

const state: PatientWithLatestVisitState = {
  patientWithLatestVisit: [],
}

const mutations = {
  [LatestVisitMutationNames.updatePatientWithLatestVisit](state: PatientWithLatestVisitState, payload): void {
    state.patientWithLatestVisit = payload
  },
}

const actions = {
  async [LatestVisitActionNames.getPatientWithLatestVisitById](
    { commit, state },
    payload: GetPatientWithLatestVisitByIdDto
  ): Promise<void> {
    const patientWithLatestVisit = camelcaseKeysDeep(await getPatientWithLatestVisitByIdQuery(payload))
    // console.log(patientWithLatestVisit)
    const newState = addOrUpdateSameKeyObjectInArray(state.patientWithLatestVisit, patientWithLatestVisit, 'id')
    commit(LatestVisitMutationNames.updatePatientWithLatestVisit, newState)
  },
}

export default {
  name: ModuleNames.patientWithLatestVisit,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
